var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-sea-eq-data-grid" },
    [
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "200px", "margin-bottom": "5px" },
        attrs: {
          "config-module": "130004",
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.finalColumnDefs,
          "row-data": _vm.finalRowData,
          "auto-fit-content": false
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c("div", { staticStyle: { width: "100%", display: "flex" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isEdit,
                expression: "isEdit"
              }
            ],
            staticStyle: {
              "text-align": "left",
              "margin-bottom": "5px",
              width: "50%"
            }
          },
          [
            _c("span", { attrs: { title: _vm.containerDesc } }, [
              _vm._v(
                _vm._s(
                  _vm.containerDesc.length > 20
                    ? _vm.containerDesc.substring(0, 40) + "..."
                    : _vm.containerDesc
                )
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "right", "margin-bottom": "5px" } },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEdit,
                    expression: "isEdit"
                  }
                ],
                attrs: { no: "Add", type: "primary" },
                on: { click: _vm.add }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEdit,
                    expression: "isEdit"
                  }
                ],
                attrs: { no: "Delete", type: "danger" },
                on: { click: _vm.remove }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }